import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { InfoboxService } from '../infobox/infobox.service';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import {
	MESSAGE_CHECK_IN_ERROR,
	MESSAGE_CHECK_OUT_ERROR,
} from '@/new-transport/transport-timetable/_store/transport-timetable.store';
import { BANK_ACCOUNT_ERROR_MESSAGE } from '@/organization/organization/organization-bank-accounts/organization-bank-accounts.component';
import { USER_ALREADY_EXISTS_ERROR } from '@/reservation/reservation-summary/reservation-summary-owner/reservation-summary-owner-dialog/reservation-summary-owner-dialog.component';
import { StatusCode } from '../enums/StatusCode';

const ERRORS_TO_IGNORE = [
	USER_ALREADY_EXISTS_ERROR,
	StatusCode.CONFLICT_RESPONSE_ERROR,
	BANK_ACCOUNT_ERROR_MESSAGE,
	MESSAGE_CHECK_IN_ERROR,
	MESSAGE_CHECK_OUT_ERROR,
];

const STATUS_MESSAGES: Record<number, string> = {
	[StatusCode.UNAUTHORIZED]: 'Sesja wygasła. Zaloguj się ponownie.',
	[StatusCode.FORBIDDEN]: 'Brak uprawnień do wykonania tej operacji.',
	[StatusCode.NOT_FOUND]: 'Nie znaleziono zasobu lub już nie istnieje.',
	[StatusCode.INTERNAL_SERVER_ERROR]: 'Wystąpił problem z serwerem. Spróbuj ponownie.',
	[StatusCode.BAD_GATEWAY]: 'Błąd pośredniego serwera (502). Spróbuj ponownie.',
	[StatusCode.SERVICE_UNAVAILABLE]: 'Usługa chwilowo niedostępna (503). Spróbuj ponownie później.',
	[StatusCode.GATEWAY_TIMEOUT]: 'Przekroczono czas odpowiedzi (504). Spróbuj ponownie.',
	[StatusCode.VALIDATION_ERROR]: 'Błąd walidacji (422). Popraw dane.',
	0: 'Brak połączenia z siecią lub problem CORS. Sprawdź internet/VPN i spróbuj ponownie.',
};

export const httpErrorsInterceptor: HttpInterceptorFn = (req, next) => {
	const infobox = inject(InfoboxService);

	return next(req).pipe(
		catchError((err: unknown) => {
			if (ERRORS_TO_IGNORE.some((errToIgnore) => JSON.stringify(err).includes(errToIgnore.toString()))) {
				return throwError(() => err);
			}

			if (err instanceof HttpErrorResponse) {
				if (err.status === StatusCode.BAD_REQUEST) {
					infobox.error(JSON.stringify(err.error));
				} else {
					const msg = STATUS_MESSAGES[err.status] ?? 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie.';
					if (err.status === StatusCode.VALIDATION_ERROR && err.error?.message) {
						let errorMessage = err.error.message;
						try {
							const parsedMessage = JSON.parse(errorMessage);
							if (typeof parsedMessage === 'object' && parsedMessage !== null) {
								errorMessage = Object.entries(parsedMessage)
									.map(([field, error]) => `${field}: ${error}`)
									.join('<br>');
							}
						} catch {}

						infobox.error(msg + '<br>' + errorMessage);
					} else {
						infobox.error(msg);
					}
				}
				console.error('HTTP error:', err);
			}

			return throwError(() => err);
		}),
	);
};
